import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {BrowserRouter} from "react-router-dom";
import { ToastProvider } from './components/context/ToastProvider';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
        <ToastProvider>
            <App/>
            </ToastProvider>
        </BrowserRouter>
    </React.StrictMode>
);


